// HUBERT — GATE ESCAPE :: obsahová data (přesné texty od klienta)
const A = "https://customer-assets.emergentagent.com/job_vhs-terror-book/artifacts";

export const ASSETS = {
  logoGate: `${A}/f27nozae_logo%20gate%20escape%20zeleny%CC%81.png`,
  logoPsychoactive: `${A}/8ykvb255_psychoactive%20escapecore%20logo%20novy%CC%81.png`,
  hero1: `${A}/kcneouaq_Hlavni%CC%81%20obra%CC%81zek%201.jpg`,
  hero2: `${A}/agmvi4x1_hlavni%CC%81%20obrazek%202.jpg`,
  chair: `${A}/uc91drxm_Hlavni%CC%81%20obra%CC%81zek%201.jpg`,
  tablet: `${A}/lr9kwqqf_tablet%20s%20noc%CC%8Cni%CC%81m%20vide%CC%8Cni%CC%81m.jpg`,
  bootIcon: "https://static.prod-images.emergentagent.com/jobs/2de5f69c-23f8-480f-a80d-073e9c5a86a9/images/f58461d391dc369a3b26272a9e76e3ad5a5a4c5cbe11004ce8371d7aa84f8dd6.png",
  polaroids: [
    `${A}/9w9e7t3h_polaroid1.png`,
    `${A}/57xtotqe_polaroid2.png`,
    `${A}/8ppw1vvt_polaroid3.png`,
    `${A}/usllh7k6_polaroid4.png`,
    `${A}/urzjm80b_polaroid5.png`,
    `${A}/znluqggy_polaroid6.png`,
    `${A}/6ggok8ro_polaroid7.png`,
    `${A}/1s0szz1o_polaroid8.png`,
    `${A}/15kupr2a_polaroid9.png`,
    `${A}/35ce9b97_polaroid10.png`,
  ],
};

export const CONTACT = {
  brand: "GATE ESCAPE",
  game: "HUBERT",
  address: "Obora 125, 358 01 Šindelová (kousek od Karlových Varů)",
  phone: "+420 778 509 940",
  phoneHref: "tel:+420778509940",
  email: "escape.hubert@gmail.com",
  instagram: "https://www.instagram.com/gateescapecz/",
  facebook: "https://www.facebook.com/gateescapecz/",
  tiktok: "https://www.tiktok.com/@gate_escape.cz",
  youtube: "https://www.youtube.com/@gate_escape",
};

export const SLOGANS = [
  "Nejděsivější místnost není v domě. Je v tobě.",
  "Každý dům má své tajemství. Tenhle zná i tvoje.",
  "Jsou věci, které lze pochopit jen tehdy, když je prožiješ.",
  "Některé dveře se po otevření už nikdy nezavřou.",
];

export const HERO = {
  kicker: "PSYCHOACTIVE ESCAPECORE",
  slogan: "Nejděsivější místnost není v domě. Je v tobě.",
  sub: "Surová Psychoactive Escapecore hra v autentickém urbex stylu. Prozkoumejte skutečný třípatrový opuštěný dům sériového vraha.",
  cta: "REZERVOVAT TERMÍN",
  ctaSecondary: "VSTOUPIT DO PŘÍBĚHU",
};

export const ESCAPECORE = {
  title: "Co znamená Escapecore?",
  body:
    "Escapecore představuje nový žánr únikových her, který se záměrně pohybuje na hranici, nebo spíše za hranicí klasické zábavy.\n\nVe hře se objevují prvky realisticky ztvárněného násilí, nahoty, psychologicky znepokojivých scén a dalších kontroverzních motivů. Cílem není šokovat samoúčelně, ale co nejvěrněji přiblížit atmosféru skutečných případů sériových vrahů bez romantizace či přikrášlování.\n\nHra je syrová, autentická a nesnaží se realitu skrývat. Celý svět hry je vytvořen tak, aby působil maximálně uvěřitelně.\n\nZ tohoto důvodu je hra přístupná pouze osobám starším 18 let. Před začátkem hry probíhá kontrola občanských průkazů.",
};

export const PSYCHOACTIVE = {
  title: "Co znamená Psychoactive?",
  body:
    "Psychoaktivní složka hry pracuje s podvědomím hráče.\n\nDo hry jsou zakomponovány speciálně navržené psychologické prvky a spouštěče, které nenásilnou formou aktivují určité procesy v lidské psychice. Tyto prvky podporují intenzitu zážitku, prohlubují atmosféru a vytvářejí jedinečný přesah během únikové hry.\n\nPsychoaktivní část není oddělenou součástí hry. Je přirozeně propojena s prostředím, příběhem i herními mechanismy, takže ji hráč často ani nevědomě nevnímá.\n\nPsychoaktivní přesah je vytvořen na základě reálných zkušeností, odborné literatury a psychologických poznatků. Část konceptu vychází z práce světově uznávaného psychiatra, terapeuta a zakladatele analytické psychologie Carla Gustava Junga. Druhou část tvoří originální autorský koncept zaměřený na práci se strachem, negativními emocemi a destruktivními psychickými stavy.",
};

export const STORY = {
  title: "Ocitněte se v epicentru destruktivní mysli",
  body:
    "Od stejných tvůrců jako legendární úniková hra ESTER: DŮM V TEMNÉM LESE.\n\nOcitněte se přímo v epicentru destruktivní mysli. Celý dům a vše, co se v něm nachází, je odrazem toho nejtemnějšího, čeho je lidská psychika schopna. Uvězněni v doupěti sériového vraha, který ale uvěznil s vámi, uvěznil v zajetí toho nejproradnějšího věznitele, a to sebe samého.\n\nHubert je sadista, ale zároveň empatický dobrák, který vám chce pomoci. Jeho pomoc se ale zakládá na utrpení a smrti. Dokážete se postavit svému stínu, zemřít a znovu se zrodit? Nebo jen odejdete s otevřenou bránou pro démony? Cože, věříte, je horší než smrt.",
  quote: "Uvězněni v doupěti sériového vraha, který uvěznil sám sebe.",
};

export const NIGHT_VISION = {
  kicker: "REVOLUČNÍ HERNÍ PRVEK",
  title: "70 % hry v naprosté tmě",
  body:
    "Přibližně 70 % celé hry probíhá v naprosté tmě.\n\nKaždý hráč má k dispozici speciálně upravený tablet s aktivním nočním viděním, díky kterému se může pohybovat temným prostředím a odhalovat detaily skryté běžnému zraku.\n\nTento originální herní prvek vytváří zcela nový typ zážitku a výrazně posiluje napětí, atmosféru i celkovou intenzitu hry.",
};

export const GAME_INFO = {
  title: "Spis hry HUBERT",
  rows: [
    { label: "Počet hráčů", value: "1 až 4 osoby" },
    { label: "Délka hry", value: "90 minut" },
    { label: "Místo konání", value: "celý skutečný třípatrový dům" },
    { label: "Obtížnost", value: "vhodná i pro úplné začátečníky" },
    { label: "Přístupnost", value: "pouze pro osoby starší 18 let" },
    { label: "Cena", value: "2 500 Kč za celou hru" },
  ],
  priceNote:
    "Cena je pevná a nemění se podle počtu hráčů. Stejná cena platí pro jednoho hráče i pro čtyřčlenný tým.",
  notice: "Hra nebude dostupná na žádných slevových portálech.",
};

export const GALLERY = {
  kicker: "ARCHIV NALEZENÝCH FOTOGRAFIÍ",
  title: "Důkazní nástěnka",
  sub: "Polaroidy nalezené v domě. Nikdo neví, kdo je pořídil.",
};

export const REVIEWS = {
  kicker: "TOHLE ŘÍKAJÍ TI, CO PŘEŽILI",
  title: "Hodnocení",
  sub: "Žádné hvězdičky. Jen upřímné reakce.",
  // 5 originálních možností (nejsou seřazené od nejhorší po nejlepší)
  options: [
    { id: 1, label: "Chci na to zapomenout." },
    { id: 2, label: "Potřebuji terapii." },
    { id: 3, label: "Vy potřebujete terapii!" },
    { id: 4, label: "Bylo to skvělé, bohužel..." },
    { id: 5, label: "Chci podat stížnost a koupit voucher." },
  ],
};

export const SAFETY = {
  title: "Bezpečnost",
  points: [
    "Během celé hry jste pod dohledem kamerového systému.",
    "Fyzicky vám nehrozí žádné nebezpečí.",
    "Hru můžete kdykoliv přerušit nebo zcela ukončit.",
    "Ve hře nevystupují žádní živí herci, se kterými byste přišli do přímého fyzického kontaktu.",
  ],
};

export const HEALTH = {
  title: "Zdravotní upozornění",
  intro: "Hra není vhodná pro:",
  points: [
    "osoby mladší 18 let",
    "těhotné ženy",
    "osoby trpící epilepsií",
    "osoby se srdečními onemocněními",
    "seniory",
    "osoby s omezenou pohyblivostí",
  ],
  note: "V objektu se nachází několik schodišť, proto je nutná dobrá pohyblivost.",
};

export const FAQ = {
  title: "Časté dotazy",
  items: [
    {
      q: "Pro koho je hra určena?",
      a: "Výhradně pro dospělé návštěvníky (18+). Před začátkem hry probíhá kontrola občanských průkazů. Hra obsahuje realisticky stylizované scény a psychologicky intenzivní atmosféru.",
    },
    {
      q: "Kolik nás může hrát a kolik to stojí?",
      a: "Hru hraje 1 až 4 osoby. Cena je pevných 2 500 Kč za celou hru bez ohledu na počet hráčů.",
    },
    {
      q: "Jak dlouho hra trvá?",
      a: "Herní čas je 90 minut. Doporučujeme dorazit s předstihem na úvodní instruktáž a kontrolu dokladů.",
    },
    {
      q: "Co je to tablet s nočním viděním?",
      a: "Přibližně 70 % hry probíhá v naprosté tmě. Každý hráč dostane speciálně upravený tablet s aktivním nočním viděním, kterým odhaluje prostředí a řeší část úkolů.",
    },
    {
      q: "Je to bezpečné?",
      a: "Ano. Po celou dobu jste pod dohledem kamerového systému a roommastera, který může kdykoliv zasáhnout. Veškeré scény jsou aranžované, žádné násilí není skutečné. Hru lze kdykoliv přerušit.",
    },
    {
      q: "Pro koho hra vhodná není?",
      a: "Pro osoby mladší 18 let, těhotné ženy, osoby s epilepsií, se srdečními onemocněními, seniory a osoby s omezenou pohyblivostí. V objektu je několik schodišť.",
    },
    {
      q: "Kde se hra nachází?",
      a: "Obora 125, 358 01 Šindelová — kousek od Karlových Varů.",
    },
  ],
};

export const CONTACT_SECTION = {
  title: "Kontakt",
  intro:
    "Máte dotaz ohledně hry HUBERT nebo našich služeb? Potřebujete poradit s rezervací? Nebo vás jen zajímá něco dalšího? Napište nám prostřednictvím kontaktního formuláře nebo nám zavolejte. Rádi vám pomůžeme.",
};

export const NAV_LINKS = [
  { href: "#o-hre", label: "O hře" },
  { href: "#nocni-videni", label: "Noční vidění" },
  { href: "#galerie", label: "Galerie" },
  { href: "#recenze", label: "Recenze" },
  { href: "#poukazy", label: "Poukazy" },
  { href: "#faq", label: "FAQ" },
  { href: "#kontakt", label: "Kontakt" },
  { href: "#socialni-site", label: "Sociální sítě", social: true },
  { href: "#rezervace", label: "Rezervovat", cta: true },
];
